import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1014a71c")

_pushScopeId("data-v-1014a71c")
const _hoisted_1 = { class: "hasHeader genericPadding" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "fs_10 grey d-block ln_12" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_7 = { class: "shipment mb-0" }
const _hoisted_8 = { class: "greyBlue" }
const _hoisted_9 = { class: "text-capitalize orange" }
const _hoisted_10 = { class: "shipment mt-0 mb-0" }
const _hoisted_11 = { class: "greyBlue" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "shipment mt-0" }
const _hoisted_15 = { class: "greyBlue" }
const _hoisted_16 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_17 = { class: "fs_14 d-block ln_12 mb-3" }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = {
  key: 0,
  class: "fs_14 d-block ln_12 mb-3"
}
const _hoisted_20 = {
  key: 1,
  class: "fs_14 d-block ln_12 mb-3"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_cart_item = _resolveComponent("cart-item")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/order-list')))
      }, [
        _hoisted_3
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_localized_text, {
          class: "fs_12 greyBlue d-block ln_12",
          localizedKey: "app_dettaglioordine",
          text: "Dettaglio ordine"
        }),
        _createVNode("span", _hoisted_5, "# " + _toDisplayString(_ctx.order.orderNumber), 1)
      ]),
      _hoisted_6
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.order.cartItems, (cartItem, index) => {
      return (_openBlock(), _createBlock("div", {
        class: "mb-3",
        key: index
      }, [
        _createVNode(_component_cart_item, { model: cartItem }, null, 8, ["model"])
      ]))
    }), 128)),
    _createVNode("div", _hoisted_7, [
      _createVNode("h4", _hoisted_8, [
        _createVNode(_component_localized_text, {
          localizedKey: 'app_fornitore',
          text: 'Fornitore'
        })
      ]),
      _createVNode("h4", _hoisted_9, [
        _createVNode("span", null, _toDisplayString(_ctx.order.communityTitle), 1)
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("h4", _hoisted_11, [
        _createVNode(_component_localized_text, {
          localizedKey: 'app_spedizione',
          text: 'Spedizione'
        })
      ]),
      (_ctx.order.shipmentCosts > 0)
        ? (_openBlock(), _createBlock("h4", _hoisted_12, [
            _createVNode("span", null, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.order.shipmentCosts)), 1)
          ]))
        : (_openBlock(), _createBlock("h4", _hoisted_13, [
            _createVNode(_component_localized_text, {
              localizedKey: 'app_gratuita',
              text: 'Gratuita'
            })
          ]))
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("h4", _hoisted_15, [
        _createVNode(_component_localized_text, {
          localizedKey: 'app_totale',
          text: 'Totale'
        })
      ]),
      _createVNode("h4", null, [
        _createVNode("span", null, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.order.totalPrice)), 1)
      ])
    ]),
    (_ctx.hasShippableItem && _ctx.order.shippingAddress)
      ? (_openBlock(), _createBlock("div", _hoisted_16, [
          _createVNode(_component_localized_text, {
            class: "fs_12 greyBlue d-block mt-2 mb-2",
            localizedKey: "app_note",
            text: "Note:"
          }),
          _createVNode("span", _hoisted_17, _toDisplayString(_ctx.order.shippingAddress.typedAddress), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_18, [
      _createVNode(_component_localized_text, {
        class: "fs_12 greyBlue d-block mt-2 mb-2",
        localizedKey: "app_note",
        text: "Note:"
      }),
      (_ctx.order.notes)
        ? (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString(_ctx.order.notes), 1))
        : (_openBlock(), _createBlock("span", _hoisted_20, "-"))
    ]),
    _createVNode("div", {
      class: ["status", _ctx.order.orderStatus == 0 ? 'pending' : 'closed']
    }, [
      (_ctx.order.orderStatus == 0)
        ? (_openBlock(), _createBlock(_component_localized_text, {
            key: 0,
            class: "fs_14 text-uppercase orange",
            localizedKey: "app_dapagare",
            text: "Da pagare"
          }))
        : (_ctx.order.orderStatus == 1)
          ? (_openBlock(), _createBlock(_component_localized_text, {
              key: 1,
              class: "fs_14 text-uppercase white",
              localizedKey: "app_pagato",
              text: "Pagato"
            }))
          : (_openBlock(), _createBlock(_component_localized_text, {
              key: 2,
              class: "fs_14 text-uppercase white",
              localizedKey: "app_concluso",
              text: "Concluso"
            }))
    ], 2)
  ]))
})